import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    minHeight: 150,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  message: {
    marginBottom: 30,
  },
});

const NoContent = props => {
  const { showButton, message, classes, clickHandler, btnText } = props;
  return (
    <div className={classes.root}>
      <Typography className={classes.message} variant="subheading">
        {message}
      </Typography>
      {showButton ? (
        <Button
          className={classes.btn}
          variant="contained"
          color="primary"
          onClick={clickHandler}
        >
          {btnText}
        </Button>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(NoContent);



// WEBPACK FOOTER //
// ./src/components/NoContent.js